import * as React from "react";
const SvgGeoposition = () => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 3.207a5.793 5.793 0 1 0 0 11.586A5.793 5.793 0 0 0 9 3.207M2.154 9a6.846 6.846 0 1 1 13.692 0A6.846 6.846 0 0 1 2.154 9",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 .75c.29 0 .527.236.527.527v2.808a.527.527 0 0 1-1.054 0V1.277C8.473.986 8.71.75 9 .75M13.388 9c0-.29.236-.527.527-.527h2.808a.527.527 0 0 1 0 1.054h-2.808A.527.527 0 0 1 13.388 9M9 13.388c.29 0 .527.236.527.527v2.808a.527.527 0 0 1-1.054 0v-2.808c0-.29.236-.527.527-.527M.75 9c0-.29.236-.527.527-.527h2.808a.527.527 0 0 1 0 1.054H1.277A.527.527 0 0 1 .75 9M9 8.824a.176.176 0 1 0 0 .351.176.176 0 0 0 0-.35M7.771 9a1.229 1.229 0 1 1 2.458 0A1.229 1.229 0 0 1 7.77 9",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9 9.702a.702.702 0 1 0 0-1.404.702.702 0 0 0 0 1.404"
  }
));
export default SvgGeoposition;
